






































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, maxLength, requiredIf } from 'vuelidate/lib/validators'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import MarketplaceTextInput from '../../components/MarketplaceTextInput/index.vue'
import MarketplaceDropdown from '../../components/MarketplaceDropdown/index.vue'
import MarketplaceAddressSelect from '../../components/MarketplaceAddressSelect/index.vue'
import ModalConfirm from '../../components/MarketplaceModal/ModalConfirm.vue'
import ModalSuccess from '../../components/MarketplaceModal/ModalSuccess.vue'
import ModalCourierNotFound from '../../components/MarketplaceModal/ModalCourierNotFound.vue'
import POSController from '@/app/ui/controllers/POSController'
import PODController from '@/app/ui/controllers/PODTrackerController'
import WhiteSellerController from '@/app/ui/controllers/WhiteSellerController'
import { POS } from '@/domain/entities/POS'
import { LocalStorage, Utils } from '@/app/infrastructures/misc'
import {
  MAX_NAME_WHITE_SELLER,
  MIN_NAME_WHITE_SELLER,
  MAX_TOTAL_PHONE_WHITE_SELLER,
} from '@/app/infrastructures/misc/Constants/validation'
import { Courier } from '@/domain/entities/Courier'
import MarketplaceInputPhone from '../../components/MarketplaceInputPhone/index.vue'
import MarketplaceRadioButton from '../../components/MarketplaceRadioButton/index.vue'
import { PODTrackerDriver } from '@/domain/entities/PODTracker'
import {
  WhiteSeller,
  WhiteSellerCorporateClient,
  WhiteSellerPickupPoint,
} from '@/domain/entities/WhiteSeller'
import { ShowSellerPhoneRequest } from '@/data/payload/api/WhiteSellerRequest'
import {
  ALL_SELLER_ROLE_OPTIONS,
  COD_HANDLING_OPTIONS,
  EnumSellerRole,
  SellerRoleOption,
} from '@/app/infrastructures/misc/Constants/manageWhitelist'

interface OptionsNumber {
  label: string
  value: number
}

interface OptionsString {
  label: string
  value: string
}

interface AddressOption {
  value: number
  name?: string
  picName?: string
  phoneNumber?: string
  address?: string
  latlon?: string
}

const CLIENT_SEARCH_DEBOUNCE_MS = 500

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    MarketplaceTextInput,
    MarketplaceDropdown,
    MarketplaceAddressSelect,
    ModalConfirm,
    ModalSuccess,
    ModalCourierNotFound,
    MarketplaceInputPhone,
    MarketplaceRadioButton,
  },
})
export default class EditSellerWhitelist extends Vue {
  POSController = POSController
  PODController = PODController
  WhiteSellerController = WhiteSellerController

  modalEditConfirm = false
  modalSuccessAdd = false
  modalCRRNFD = false

  statusOptions: OptionsString[] = [
    { label: 'Aktif', value: 'ACTIVE' },
    { label: 'Tidak Aktif', value: 'INACTIVE' },
  ]
  // Includes legacy MERCHANT and COMPANY; labels are resolved by value
  sellerRoleOptions: SellerRoleOption[] = ALL_SELLER_ROLE_OPTIONS
  codHandlingOptions = COD_HANDLING_OPTIONS
  partnerPOSOptions = <OptionsNumber[]>[]
  driverListOptions = <OptionsString[]>[]
  currentAgent = null as any

  form = {
    id: 0,
    name: '',
    phone: '',
    phoneCode: '+62',
    status: this.statusOptions[0],
    sellerRole: null as SellerRoleOption | null,
    agentId: null as OptionsNumber | null,
    courierId: '' as any,
    assignType: '' as any,
    codHandling: null as OptionsString | null,
    assignTo: 'pos',
    // Corporate only
    client: null as OptionsNumber | null,
    pcaIds: [] as number[],
  }

  currentPartnerId = 0
  parameters = {
    page: 1,
    per_page: 100,
    search: '',
    sort_by: 'ASC',
    filter_status: 'ACTIVE',
  }
  courierParameters = {
    page: 1,
    per_page: 100,
    q: '',
    sort_by: 'ASC',
    courier_status: 'ACTIVE',
    driver_type: '',
  }
  MAX_NAME_WHITE_SELLER = MAX_NAME_WHITE_SELLER
  assignToOptions = [
    { label: 'POS', value: 'pos' },
    { label: 'Kurir', value: 'courier' },
  ]

  // Corporate lookups
  clientOptions = <OptionsNumber[]>[]
  clientKeyword = ''
  isLoadingClients = false
  isClientError = false
  clientRequestId = 0

  pickupPoints = <WhiteSellerPickupPoint[]>[]
  isLoadingPickupPoints = false
  isPickupPointError = false
  pickupRequestId = 0
  initialClientId = 0

  created(): void {
    this.fetchData()
  }

  get myAccessMenus(): string[] {
    return JSON.parse(
      LocalStorage.getLocalStorage(LocalStorage.ACCESS_MENU, true)
    )
  }

  get roleValue(): string {
    return this.form.sellerRole?.value || ''
  }

  get isCorporate(): boolean {
    return this.roleValue === EnumSellerRole.COMPANY
  }

  get showCODHandlingDropdown(): boolean {
    return this.roleValue === EnumSellerRole.CLIENT
  }

  get showPartnerPos(): boolean {
    return this.form.assignTo === 'pos'
  }

  get isStatusActive(): boolean {
    return this.form.status?.value === 'ACTIVE'
  }

  get addressOptions(): AddressOption[] {
    const seen = new Set<number>()
    return this.pickupPoints.reduce((options, point) => {
      const id = Number(point.pcaId)
      if (id > 0 && !seen.has(id)) {
        seen.add(id)
        options.push({
          value: id,
          name: point.pcaName,
          picName: point.pcaPicName,
          phoneNumber: point.pcaPhoneNumber,
          address: point.pcaAddress,
          latlon: point.pcaLatlon,
        })
      }
      return options
    }, [] as AddressOption[])
  }

  get nameErrorMessage(): string {
    const length = this.form.name.trim().length
    return length > 0 &&
      (length < MIN_NAME_WHITE_SELLER || length > MAX_NAME_WHITE_SELLER)
      ? `Nama harus ${MIN_NAME_WHITE_SELLER} sampai ${MAX_NAME_WHITE_SELLER} karakter`
      : ''
  }

  get phoneErrorMessage(): string {
    return this.form.phone && !this.isPhoneLengthValid()
      ? `Nomor telepon maksimal ${MAX_TOTAL_PHONE_WHITE_SELLER} karakter`
      : ''
  }

  private isPhoneLengthValid(): boolean {
    return (
      `${this.form.phoneCode}${this.form.phone}`.length <=
      MAX_TOTAL_PHONE_WHITE_SELLER
    )
  }

  private async fetchData(posOnly?: boolean) {
    await POSController.getPOSData(this.parameters)
    await PODController.getDriverList(this.courierParameters)
    if (!posOnly && this.$route.params.id) {
      await WhiteSellerController.getDetail(this.$route.params.id)
    }
  }

  // ---- Corporate: Client & Address ----------------------------------------

  private async fetchClients(keyword: string, force = false) {
    if (!force && keyword === this.clientKeyword) return

    const requestId = ++this.clientRequestId
    this.clientKeyword = keyword
    this.isLoadingClients = true
    this.isClientError = false

    try {
      const clients: WhiteSellerCorporateClient[] =
        (await WhiteSellerController.getCorporateClients(keyword)) || []
      if (requestId !== this.clientRequestId) return
      this.clientOptions = clients.map(client => ({
        label: `${client.clientCode}-${client.clientName}`,
        value: Number(client.clientId),
      }))

      // If form.client exists, re-sync its label from the client list
      if (this.form.client) {
        const found = this.clientOptions.find(
          c => c.value === this.form.client?.value
        )
        if (found) this.form.client = found
      }
    } catch (error) {
      if (requestId !== this.clientRequestId) return
      this.clientOptions = []
      this.isClientError = true
    } finally {
      if (requestId === this.clientRequestId) this.isLoadingClients = false
    }
  }

  private onSearchClient = Utils.debounce((keyword: string) => {
    this.fetchClients(keyword || '')
  }, CLIENT_SEARCH_DEBOUNCE_MS)

  private onSelectClient(client: OptionsNumber | null) {
    this.form.client = client
    this.pickupRequestId++
    this.form.pcaIds = []
    this.pickupPoints = []
    this.isPickupPointError = false
    this.isLoadingPickupPoints = false

    if (client) {
      if (Number(client.value) === this.initialClientId) {
        this.loadCorporateAddresses(this.form.id, this.initialClientId)
      } else {
        this.fetchUnboundPickupPoints(client.value)
      }
    }
  }

  private async loadCorporateAddresses(
    whitelistId: number | string,
    clientId: number
  ) {
    const requestId = ++this.pickupRequestId
    this.isLoadingPickupPoints = true
    this.isPickupPointError = false

    try {
      // 1. Fetch all bound pickup points across all pages (API-FE-09)
      const boundPoints = await this.fetchAllBoundPickupPoints(
        String(whitelistId)
      )

      // 2. Fetch unbound pickup points for this client (API-FE-08)
      let unboundPoints: WhiteSellerPickupPoint[] = []
      if (clientId) {
        unboundPoints =
          (await WhiteSellerController.getCorporatePickupPoints(clientId)) || []
      }

      if (requestId !== this.pickupRequestId) return

      // 3. Union and deduplicate by pcaId
      const map = new Map<number, WhiteSellerPickupPoint>()
      for (const point of boundPoints) {
        const id = Number(point.pcaId)
        if (id > 0) map.set(id, point)
      }
      for (const point of unboundPoints) {
        const id = Number(point.pcaId)
        if (id > 0 && !map.has(id)) {
          map.set(id, point)
        }
      }
      this.pickupPoints = Array.from(map.values())

      // 4. Pre-tick all bound pickup points
      this.form.pcaIds = boundPoints
        .map(p => Number(p.pcaId))
        .filter(id => id > 0)
    } catch (error) {
      if (requestId !== this.pickupRequestId) return
      this.pickupPoints = []
      this.isPickupPointError = true
    } finally {
      if (requestId === this.pickupRequestId) {
        this.isLoadingPickupPoints = false
      }
    }
  }

  private async fetchAllBoundPickupPoints(
    id: string
  ): Promise<WhiteSellerPickupPoint[]> {
    let page = 1
    const limit = 50
    const results: WhiteSellerPickupPoint[] = []
    let hasMore = true

    while (hasMore) {
      const resp = await WhiteSellerController.getBoundPickupPoints({
        id,
        page,
        limit,
        reveal: true,
      })
      const points = resp?.data || []
      results.push(...points)
      const total = resp?.pagination?.totalItem || 0
      if (
        points.length < limit ||
        results.length >= total ||
        points.length === 0
      ) {
        hasMore = false
      } else {
        page++
      }
    }
    return results
  }

  private async fetchUnboundPickupPoints(clientId: number) {
    const requestId = ++this.pickupRequestId
    this.isLoadingPickupPoints = true
    this.isPickupPointError = false

    try {
      const points: WhiteSellerPickupPoint[] =
        (await WhiteSellerController.getCorporatePickupPoints(clientId)) || []
      if (requestId !== this.pickupRequestId) return
      this.pickupPoints = points
    } catch (error) {
      if (requestId !== this.pickupRequestId) return
      this.pickupPoints = []
      this.isPickupPointError = true
    } finally {
      if (requestId === this.pickupRequestId) {
        this.isLoadingPickupPoints = false
      }
    }
  }

  private retryFetchPickupPoints() {
    if (!this.form.client) return
    if (Number(this.form.client.value) === this.initialClientId) {
      this.loadCorporateAddresses(this.form.id, this.initialClientId)
    } else {
      this.fetchUnboundPickupPoints(this.form.client.value)
    }
  }

  // ---- Assignment ---------------------------------------------------------

  private onSearchPartnerPOS = Utils.debounce((keyword: string) => {
    if (keyword) {
      POSController.getPOSData({
        ...this.parameters,
        search: keyword,
      })
    }
  }, 500)

  private onSelectPartnerPOS(pos: OptionsNumber) {
    if (pos) POSController.getCourierList(String(pos.value))
  }

  private handleCancelModalCRRNFD() {
    this.modalCRRNFD = false
    this.form.agentId = this.currentAgent
  }

  private handleNewCourier() {
    if (this.myAccessMenus && this.myAccessMenus.includes('manage-courier')) {
      const routeData = this.$router.resolve({ name: 'CreateManageCourierPage' })
      window.open(routeData.href, '_blank')
    } else {
      this.form.agentId = null
      this.$notify({
        title: 'Forbidden Access',
        text: 'Please request access to admin',
        type: 'error',
        duration: 3000,
      })
      this.modalCRRNFD = false
    }
  }

  private onBackToList() {
    this.$router.push({ name: 'ManageWhitelist' })
  }

  private async onSubmit() {
    if (WhiteSellerController.isLoading || !this.form.sellerRole) return

    const payload = this.buildPayload()
    const updated = await WhiteSellerController.updateWhiteSeller(payload)

    // Failure keeps the form; close confirmation modal so user can retry
    if (updated === false) {
      this.modalEditConfirm = false
    }
  }

  private buildPayload(): {
    id: number
    name: string
    phone?: string
    status: string
    agentId?: number[]
    role: string
    codHandling?: string
    courierId?: number
    assignType?: string
    clientId?: number
    pcaIds?: number[]
  } {
    const payload: any = {
      id: this.form.id,
      name: this.form.name.trim(),
      status: this.form.status.value,
      role: this.roleValue,
    }

    if (this.isCorporate) {
      payload.clientId = this.form.client?.value
      payload.pcaIds = [...this.form.pcaIds]
    } else {
      payload.phone = `${this.form.phoneCode}${this.form.phone}`
      if (this.showCODHandlingDropdown && this.form.codHandling?.value) {
        payload.codHandling = this.form.codHandling.value
      }
    }

    if (this.showPartnerPos) {
      if (this.form.agentId?.value) {
        payload.agentId = [this.form.agentId.value]
      }
    } else {
      if (this.form.courierId?.value) {
        payload.courierId = Number(this.form.courierId.value)
      }
      if (this.form.assignType?.value) {
        payload.assignType = this.form.assignType.value
      }
    }

    return payload
  }

  private onPhoneCodeChange(phoneCode: string) {
    this.form.phoneCode = phoneCode
  }

  private onSearchDriverList = Utils.debounce((keyword: string) => {
    const params = {
      ...this.courierParameters,
      q: this.replacePhoneNumber(keyword || ''),
    }
    this.PODController.getDriverList(params)
  }, 500)

  private replacePhoneNumber(text: string): string {
    if (/^08([0-9]+)$/.test(text)) {
      return Utils.countryIndonesiaPhoneNumber(text).trim()
    }
    return text
  }

  get assignTypeOptions(): OptionsString[] {
    return [
      { label: 'Offer', value: 'OFFER' },
      { label: 'Auto Assign', value: 'AUTO ASSIGN' },
    ]
  }

  private onChangeAssignTo() {
    this.form.courierId = ''
    this.form.assignType = ''
    this.form.agentId = null
  }

  @Validations()
  validations() {
    const isPosOrCourierRequired = this.isStatusActive
    const isAssignToPos = this.showPartnerPos
    const isCorporate = this.isCorporate
    const isPhoneLengthValid = () => this.isPhoneLengthValid()
    const hasMinNameLength = (value: string) =>
      Boolean(value && value.trim().length >= MIN_NAME_WHITE_SELLER)

    return {
      form: {
        sellerRole: { required },
        name: {
          required,
          minLength: hasMinNameLength,
          maxLength: maxLength(MAX_NAME_WHITE_SELLER),
        },
        phone: {
          required: requiredIf(() => !isCorporate),
          maxLength: () => isCorporate || isPhoneLengthValid(),
        },
        client: { required: requiredIf(() => isCorporate) },
        pcaIds: { required: requiredIf(() => isCorporate) },
        status: { required },
        agentId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && isAssignToPos
          }),
        },
        courierId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          }),
        },
        assignType: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          }),
        },
      },
    }
  }

  @Watch('POSController.posData')
  setPOSPartner(data: POS[]): void {
    const POSOptions = data.map(item => ({
      label: `${item.name} [${item.code}]`,
      value: item.id,
    })) as OptionsNumber[]
    this.partnerPOSOptions = POSOptions
    const currentPOS = POSOptions.find(
      item => item.value === this.currentPartnerId
    )
    if (currentPOS) {
      this.form.agentId = currentPOS
    }
    if (!this.currentAgent) {
      this.currentAgent = currentPOS
    }
    if (currentPOS) this.onSelectPartnerPOS(currentPOS)
  }

  @Watch('POSController.posCourier')
  setPOSCourier(data: Courier[]): void {
    if (data && data.length === 0) {
      this.modalCRRNFD = true
    }
  }

  @Watch('WhiteSellerController.dataWhiteSeller')
  async updateForm(val: WhiteSeller): Promise<void> {
    if (!val || !val.id) return

    this.parameters = {
      ...this.parameters,
      search: <string>val.partnerPOS,
    }
    this.currentPartnerId = <number>val.partnerId
    await this.fetchData(true)

    // Seller Role
    const matchedRole =
      this.sellerRoleOptions.find(item => item.value === val.role) || null

    // Courier label setup
    let courierLabel = `${val.courierId} - ${val.courierName}`
    if (val.courierId) {
      this.courierParameters.q = val.courierName || ''
      await this.PODController.getDriverList(this.courierParameters)
      this.courierParameters.q = ''
      const courierData = this.PODController.driverData.find(
        driver => driver.courierId === val.courierId
      )
      if (courierData) {
        courierLabel = `[${courierData.courierId}] ${courierData.fullname} (${courierData.announcementCourierType}) ${courierData.phoneNumber} • ${courierData.partnerName}`
      }
    }

    // Phone setup (non-corporate only)
    let parsedPhone = ''
    let parsedPhoneCode = '+62'
    if (val.role !== EnumSellerRole.COMPANY) {
      try {
        const phoneResp = await WhiteSellerController.showWhitelistSellerPhone(
          new ShowSellerPhoneRequest({
            id: val.id,
            source: 'whitelist-edit',
            type: val.role,
          })
        )
        const rawPhone = phoneResp?.phone || val.phone || ''
        if (rawPhone.startsWith('+62')) {
          parsedPhoneCode = '+62'
          parsedPhone = rawPhone.slice(3)
        } else if (rawPhone.startsWith('62')) {
          parsedPhoneCode = '+62'
          parsedPhone = rawPhone.slice(2)
        } else {
          parsedPhoneCode = '+62'
          parsedPhone = rawPhone
        }
      } catch (e) {
        parsedPhone = val.phone || ''
      }
    }

    this.form = {
      id: Number(val.id),
      name: String(val.name || ''),
      phone: parsedPhone,
      phoneCode: parsedPhoneCode,
      status:
        this.statusOptions.find(item => item.value === val.status) ||
        this.statusOptions[0],
      agentId: val.partnerId
        ? {
            label: `${val.partnerPOS} [${val.partnerCode}]`,
            value: Number(val.partnerId),
          }
        : null,
      sellerRole: matchedRole,
      codHandling:
        this.codHandlingOptions.find(item => item.value === val.codHandling) ||
        null,
      assignTo: val.courierId ? 'courier' : 'pos',
      courierId: val.courierId
        ? { label: courierLabel, value: Number(val.courierId) }
        : ('' as any),
      assignType:
        this.assignTypeOptions.find(
          item => item.value === val.assignType?.toUpperCase()
        ) || ('' as any),
      client: null,
      pcaIds: [],
    }

    // Corporate (COMPANY) setup
    if (val.role === EnumSellerRole.COMPANY) {
      this.initialClientId = Number(val.clientId || 0)
      this.form.client = this.initialClientId
        ? {
            label: val.clientName || 'Client',
            value: this.initialClientId,
          }
        : null
      await this.fetchClients('', true)
      if (this.initialClientId) {
        await this.loadCorporateAddresses(val.id, this.initialClientId)
      }
    }

    await PODController.getDriverList(this.courierParameters)
  }

  @Watch('PODController.driverData')
  setDriverList(data: PODTrackerDriver[]): void {
    const DriverOption = data.map(item => {
      const label = `[${item.courierId}] ${item.fullname} (${item.announcementCourierType}) ${item.phoneNumber} • ${item.partnerName}`
      return {
        label,
        value: item.courierId?.toString(),
      }
    }) as OptionsString[]
    this.driverListOptions = DriverOption
  }

  @Watch('form.status')
  onStatusChange(): void {
    // Re-evaluates target requirements automatically via isStatusActive
  }

  @Watch('WhiteSellerController.isEditWhiteSellerSuccess')
  onEditWhiteSellerSuccess(val: boolean): void {
    if (val) {
      this.modalEditConfirm = false
      this.modalSuccessAdd = val
    }
  }

  @Watch('form.name')
  setSellerName(data: string): void {
    if (!data) return
    this.form.name = Utils.removeHTMLTags(
      Utils.removeSpecialCharacters(Utils.removeScriptTags(data))
    )
  }

  beforeDestroy(): void {
    this.WhiteSellerController.setIsEditWhiteSellerSuccess(false)
  }
}
